import { DataTheme } from 'src/Enums'

export enum Graph {
  CO2Levels = 'CO2Levels'
}

export enum GraphGroup {
  CO2Levels = 'CO2Levels'
}

export interface GraphDescription {
  name: string
  description: string
  type: Graph
}

export interface GraphGroupDescription {
  name: string
  description: string
  type: GraphGroup
  graphs: Graph[]
  themes: DataTheme[]
}

/**
 * Gets the available GraphGroups for a given DataTheme
 * @param dataTheme The DataTheme for which to get the available GraphGroups
 * @returns A list of available GraphGroups
 */
export const getGraphsGroupsByDataTheme = (dataTheme: DataTheme): GraphGroup[] => {
  if (dataTheme === DataTheme.NONE) {
    return Object.values(GraphGroup)
  }
  return Object.values(GraphGroup).filter(graphGroup => getGraphGroupDescriptionForType(graphGroup).themes.includes(dataTheme))
}

/**
 * Gets the GraphGroup's for a given DataTheme
 * @param dataTheme The DataTheme for which to get the GraphGroup's
 * @returns A list of GraphGroup's
 */
export const getGraphGroups = (dataTheme: DataTheme): GraphGroup[] => {
  const groups = getGraphsGroupsByDataTheme(dataTheme)
  return groups
    .map(group => getGraphGroupDescriptionForType(group).type)
    .filter((value, index, self) => self.indexOf(value) === index) // remove duplicates
}

/**
 * Gets the description of a GraphGroup
 * @param type the GraphGroup to be descriped
 * @returns A GraphGroupDescription
 */
export const getGraphGroupDescriptionForType = (graphGroup: GraphGroup): GraphGroupDescription => {
  switch (graphGroup) {
    case GraphGroup.CO2Levels:
      return {
        name: 'layerpicker.co2levelsorg.title',
        description: 'layerpicker.co2levelsorg.description',
        type: GraphGroup.CO2Levels,
        graphs: [Graph.CO2Levels],
        themes: Object.values(DataTheme)
      }
  }
}

/**
 * Gets the description of a Graph
 * @param type the Graph to be descriped
 * @returns A GraphDescription
 */
export const getGraphDescriptionForType = (graph: Graph): GraphDescription => {
  switch (graph) {
    case Graph.CO2Levels:
      return {
        name: 'layerpicker.graphs.button',
        description: '',
        type: Graph.CO2Levels
      }
  }
}
